import { ChevronLeft } from 'lucide-react';
import { Link, useParams } from 'react-router';

import { AdminPage } from '@/components/admin/AdminPage';
import { ConversationPane } from './conversations/ConversationPane';

/*
 * One conversation on its own page — ROADMAP.md §9.3.
 *
 * **Almost nothing here, and that is the point.** The whole thread lives in
 * `ConversationPane`, which the inbox also renders and which 9.7 puts on the
 * client record. A customer's history reading differently depending on where it
 * was opened is the bug this shape prevents, so this page is a title, a way
 * back, and the same component.
 *
 * It exists as a route because a conversation reference is a thing people send
 * each other — "have a look at C-2026-0041" should be a link.
 */

export function ConversationDetailPage() {
  const { id = '' } = useParams();

  return (
    <AdminPage
      title="Conversation"
      description="Every message to and from this customer, in order."
    >
      <Link
        to="/admin/conversations"
        className="mb-3 inline-flex min-h-11 items-center text-meta text-bark-700"
      >
        <ChevronLeft aria-hidden="true" className="mr-1 size-4" />
        All conversations
      </Link>

      <ConversationPane id={id} />
    </AdminPage>
  );
}
